import * as React from 'react';
import {PlaylistAsset} from '../../../../models/PlaylistAsset/PlaylistAsset';
import {IAssetDetails, IErrorLog, IAssetImages} from '../../../../../@types/assetDetails';
import {IEnums} from '../../../../state/IEnums';
import {deepCopy} from '../../utils/helpers';
import {Tt2b} from '../../../../components/Typography';
import {ImageRecord} from './components/ImageRecord';

interface IImageProps {
  selectedAsset: PlaylistAsset;
  updatedAssetDetails: Partial<IAssetDetails>;
  enums: IEnums;
  tabsDataInEditMode: boolean;
  closestBody?: HTMLElement;
  errorLogs: Array<IErrorLog>;
  updatePartialAssetDetails: (assetDetails: Partial<IAssetDetails>) => void;
}

export class Image extends React.PureComponent<IImageProps> {
  getAssetData = () => {
    const currentAssetDetails =
      this.props.selectedAsset && this.props.selectedAsset.assetDetails ? this.props.selectedAsset.assetDetails : {};
    const updatedAssetDetails = this.props.updatedAssetDetails || [];
    return deepCopy({...currentAssetDetails, ...updatedAssetDetails});
  };

  handlePropUpdate = (imageId: string, prop: string, value: string | number) => {
    const currentAssetDetails = this.getAssetData();
    const images = (currentAssetDetails.images || []).reduce((acc: Array<IAssetDetails>, image: IAssetImages) => {
      if (image.id === imageId) {
        image = {...image, [prop]: value};
      }
      return [...acc, image];
    }, []);
    this.props.updatePartialAssetDetails({...this.props.updatedAssetDetails, images});
  };

  getContent = () => {
    const images = this.getAssetData().images || [];
    if (!images.length) {
      return (
        <Tt2b className="image-details-container_empty" content="No Image configurations are defined for this asset" />
      );
    }
    return images.reduce((acc: Array<JSX.Element>, image: IAssetImages, index: number) => {
      const imageElement = (
        <ImageRecord
          key={index}
          image={image}
          enums={this.props.enums}
          closestBody={this.props.closestBody}
          tabsDataInEditMode={this.props.tabsDataInEditMode}
          errorLogs={this.props.errorLogs}
          updateProp={this.handlePropUpdate}
        />
      );
      return [...acc, imageElement];
    }, []);
  };

  render() {
    return <div className="image-details-container">{this.getContent()}</div>;
  }
}
